module.exports = __webpack_public_path__ + "static/logo-ld-logo-on-dark@3x-b2639144647ebc94ae2f67021c6d01cf.png";